<section id="info-corporativa" class="corporate-info m-section">
    <div class="container">
        <div class="header">
            <!-- <div class="subtitle-badge">{{ subtitle }}</div> -->
            <app-badge [text]="subtitle"></app-badge>
            <h2 class="">{{ title }}</h2>
            <p class="header-description">{{ headerDescription }}</p>
        </div>
        <div class="features">
            <div class="feature" *ngFor="let card of cards" data-aos="fade-up" [attr.data-aos-delay]="card.delay"
                data-aos-duration="800">
                <app-corner-card [title]="card.title" [description]="card.description" [image]="card.image"
                    [alt]="card.alt">
                </app-corner-card>
            </div>
        </div>
    </div>

</section>